import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMCompoundFieldService } from '@services/lm-compound-field.service';

export const lmCodeBlockSerializer = (
  lmFormatUtilService: LMFormatUtilService,
  lmCompoundFieldService: LMCompoundFieldService,
  value: string,
  oldValue: string,
  columnDef: ListGridColumn,
  row: number,
  cell: number,
  dataView: LMListDataView
): string => lmCompoundFieldService.computeCompactFieldValue(dataView, columnDef.fieldId);
